import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";

//Helper functions
import { getSettings, notifyError, notifySuccess, handleDownloadPrikbord, getFileContentsPrikbord } from '../../../settings/Helpers';

//API
import api from '../../../settings/AxiosSetup';

//3rd party
import toast, { Toaster } from 'react-hot-toast';
import * as Icon from 'react-bootstrap-icons';
import Skeleton from 'react-loading-skeleton';
import 'moment/locale/nl';
import moment from 'moment';
import 'moment-timezone';
import { confirmAlert } from 'react-confirm-alert';
import { Tooltip } from 'react-tooltip';
import { TailSpin } from  'react-loader-spinner';
import Select from 'react-select';
import { exportToExcel } from 'react-json-to-excel';

//Components
import SideNav from '../../../components/sidenav/sidenav';
import BottomNav from '../../../components/bottomnav/bottomnav';
import DashboardHeader from '../../../components/dashboard/header';

//Assets
import svzArtwork from '../../../assets/images/artwork-svz.svg';

//styles
import './evenementen.css';
import 'rodal/lib/rodal.css';
import 'react-pulse-dot/dist/index.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-tooltip/dist/react-tooltip.css';

const Evenement = () => {

    //Set variables
    const { id } = useParams();
    const navigate = useNavigate();
    const loggedIn = localStorage.getItem('ingelogd');
    const medewerker = JSON.parse(localStorage.getItem('medewerker'));
    const environment = process.env.REACT_APP_APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [userPoints, setUserPoints] = useState(0);
    const [eventInfo, setEventInfo] = useState({});
    const [spotsBooked, setSpotsBooked] = useState(0);
    const [registrations, setRegistrations] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [withPartner, setWithPartner] = useState(false);
    const [visible, setVisible] = useState(true);
    const [checkExtraPayment, setCheckExtraPayment] = useState(false);
    const [description, setDescription] = useState('');
    const [showSignUpForm, setShowSignUpForm] = useState(false);
    const [isRegistering, setIsRegistering] = useState(false);
    const [registered, setRegistered] = useState(false);
    const [idRegistration, setIdRegistration] = useState(0);
    const [isPast, setIsPast] = useState(false);

    const getEvent = async () => {
        try {
            const response = await api.get('/evenementen/' + id);
            if (response.data) {
                setUserPoints(response.data.medewerker_punten);
                setEventInfo(response.data.event);
                const userRegistration = response.data.registraties.find(reg => reg.medewerker.id === medewerker.id);
                setRegistered(!!userRegistration);
                setIdRegistration(userRegistration ? userRegistration.id : null);
                setRegistrations(response.data.registraties);
                const dateToCheck = moment(response.data.event.aanmelden_voor);
                setSpotsBooked(response.data.spots_booked);
                setIsPast(dateToCheck.isBefore(moment()));
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const downloadRegistrations = async () => {
        try {
            const response = await api.get('/evenementen/exporteren/' + id);
            if (response.data) {
                exportToExcel(response.data.excel_data, response.data.event);
            }
        } catch (error) {
            console.log(error);
        }
    }
    

    const signUp = async (event) => {
        event.preventDefault();
        setIsRegistering(true);
        try {
            const response = await api.post('/aanmeldingen', {
                data: {
                    postedEvent: id,
                    description: description,
                    withPartner: withPartner,
                    firstName: firstName,
                    lastName: lastName,
                    visible: visible,
                    checkExtraPayment: checkExtraPayment
                }
            });
            if (response.data) {
                notifySuccess('Je bent succesvol aangemeld voor dit evenement');
                getEvent();
            }
        } catch (error) {
            switch(error.response.status) {
                case 403:
                    notifyError(error.response.data.error);
                  break;
                //Default for 400 
                default:
                    notifyError('Er is iets fout gegaan. Probeer eerst even opnieuw in te loggen.');
            }
        }
        setIsRegistering(false);
    }

    const signOff = async () => {
        try {
            const response = await api.post('/aanmeldingen/afmelden/' + idRegistration, {
                data: {
                    postedEvent: id
                }
            });
            if (response.data) {
                notifySuccess('Je hebt je succesvol afgemeld voor dit evenement');
                getEvent();
            }
        } catch (error) {
            switch(error.response.status) {
                case 403:
                    notifyError(error.response.data.error);
                  break;
                //Default for 400 
                default:
                    notifyError('Er is iets fout gegaan. Probeer eerst even opnieuw in te loggen.');
            }
        }
    }

    const changeWithPartner = () => {
        setWithPartner(!withPartner);
    }
    const changeVisible = () => {
        setVisible(!visible);
    }
    const changePayment = () => {
        setCheckExtraPayment(!checkExtraPayment);
    }
    
    //Check some things on page load and redirect if not authenticated
    useEffect(() => {
        //Get settings and check for maintenance
        const settings = getSettings();
        settings.then((result) => {
            if (result.onderhoudsmodus) {
                navigate('/onderhoud');
            }
        });
        if (loggedIn !== 'true') {
            navigate('/login');
        }
        getEvent();
    }, []);
    
    return (
    <div id="main" className="dashboard">
        <SideNav page="/evenement" />
        <div className="dashboard-content">
            <DashboardHeader title={'Evenementen'} subtitle={'Mijn saldo: ' + userPoints + ' punten'} />
            <a href="/evenementen" className="back-to-list">Terug naar overzicht</a>
            {
                isLoading ?
                <TailSpin
                    height="20"
                    width="20"
                    color="#cb0a32"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />
                :
                <div className="event-info">
                    <div className="column">
                        <div className="event-meta-info">
                            <div className="event-title">
                                <h2>{eventInfo.naam}</h2>
                                <div className="extra-meta">
                                    <div className="event-meta-item">
                                        <Icon.GeoAlt color={'#e10514'} />
                                        <p>{eventInfo.locatie}</p>
                                    </div>
                                    <div className="event-meta-item">
                                        <Icon.Calendar color={'#e10514'} />
                                        <p>{moment(eventInfo.datum).format('DD-MM-YYYY')}</p>
                                    </div>
                                    <div className="event-meta-item">
                                        <Icon.PeopleFill color={'#e10514'} />
                                        <p>{eventInfo.aantal_plekken} plekken</p>
                                    </div>
                                </div>
                            </div>
                            <div className="event-points">
                                <div className="points"><p>{eventInfo.punten}</p><span>Punten</span></div>
                                {eventInfo.eigen_bijdrage ? <div className="extra-money"><p>€ {eventInfo.eigen_bijdrage}</p><span>Eigen bijdrage</span></div> : null}
                            </div>
                        </div>
                        <div className="event-content">
                            <p>{eventInfo.content}</p>
                        </div>
                        {
                            registered ?
                            <>
                            {
                                isPast ?
                                <p>De datum om je aan- of af te melden is verstreken. Mocht je jezelf alsnog willen afmelden neem dan contact op met personeelszaken.</p>
                                :
                                <>
                                    <p>Je bent al aangemeld voor dit evenement</p>
                                    <button onClick={() => signOff()} className="button red">Ik wil mezelf afmelden</button>
                                </>
                            }
                            </>
                            
                            :
                            <div className="sign-up">
                                {
                                    (eventInfo.aantal_plekken - spotsBooked > 0) && !isPast ?
                                    <>
                                    {
                                        !showSignUpForm ?
                                        <>
                                        {
                                            userPoints < eventInfo.punten ?
                                            <p className="error">Jouw saldo ({userPoints}) is niet genoeg om jezelf aan te melden voor dit evenement</p>
                                            :
                                            <button onClick={() => setShowSignUpForm(true)} className="button red">Ik wil me aanmelden</button>
                                        }
                                        </>
                                        :
                                        <form id="sign-up" onSubmit={signUp}>
                                            <label className="checkbox">
                                                <input type="checkbox" checked={withPartner} onChange={changeWithPartner} disabled={isRegistering} />
                                                <span className="checkbox-label">Ik neem mijn partner mee ({eventInfo.punten_partner} extra punten)</span>
                                            </label>
                                            {
                                                withPartner ?
                                                <div className="two-column">
                                                    <input type="text" name="first-name" placeholder="Voornaam partner" className="form-field" value={firstName} onChange={(e) => setFirstName(e.target.value)} required={withPartner} disabled={isRegistering} />
                                                    <input type="text" name="last-name" placeholder="Achternaam partner" className="form-field" value={lastName} onChange={(e) => setLastName(e.target.value)} required={withPartner} disabled={isRegistering} />
                                                </div>
                                                :
                                                null
                                            }
                                            <textarea placeholder={eventInfo.label_opmerking} className="form-field" rows="5" value={description} onChange={(e) => setDescription(e.target.value)} disabled={isRegistering}></textarea>
                                            <label className="checkbox">
                                                <input type="checkbox" checked={visible} onChange={changeVisible} disabled={isRegistering} />
                                                <span className="checkbox-label">Andere collega's mogen zien dat ik mijzelf heb ingeschreven</span>
                                            </label>
                                            {
                                                eventInfo.eigen_bijdrage ?
                                                <label className="checkbox">
                                                    <input type="checkbox" checked={checkExtraPayment} onChange={changePayment} required={eventInfo.eigen_bijdrage} disabled={isRegistering} />
                                                    <span className="checkbox-label">Ik ga akkoord met een eigen bijdragen van € {eventInfo.eigen_bijdrage}</span>
                                                </label>
                                                :
                                                null
                                            }
                                            <div className="form-footer">
                                                {
                                                    isRegistering ?
                                                    <TailSpin
                                                        height="20"
                                                        width="20"
                                                        color="#cb0a32"
                                                        ariaLabel="tail-spin-loading"
                                                        radius="1"
                                                        wrapperStyle={{}}
                                                        wrapperClass=""
                                                        visible={true}
                                                    />
                                                    :
                                                    <>
                                                        <input type="submit" value="Aanmelding afronden" className="button red" />
                                                        <p>Je huidige saldo is <strong>{userPoints}</strong> punten, na deze inschrijving is je saldo nog <strong>{!withPartner ? userPoints - eventInfo.punten : userPoints - (eventInfo.punten + eventInfo.punten_partner)}</strong></p>
                                                    </>
                                                }
                                                
                                            </div>
                                        </form>
                                    }
                                    </>
                                    :
                                    <p>Je kunt je niet meer aanmelden voor dit evenement</p>
                                }
                            </div>
                        }
                        
                    </div>
                    <div className="column">
                        {eventInfo.afbeelding ? <img src={environment + '' + eventInfo.afbeelding.url} /> : null}
                        <div className="attenders">
                            <div className="attenders-content">
                                <div className="attenders-header">
                                    <h3>Deelnemers</h3>
                                    <div className="attenders-actions">
                                        <h3>{spotsBooked + '/' + eventInfo.aantal_plekken}</h3>
                                        {registrations.length > 0 && medewerker.evenementen_exporteren ? <Icon.FileEarmarkSpreadsheet className="export-registrations" onClick={() => downloadRegistrations()} size={20} color={'#1E6E42'} /> : null}
                                    </div>
                                </div>
                                <div className="attenders-list">
                                {
                                    registrations && registrations.length > 0 ?
                                    <>
                                    {
                                        registrations.map((item, index) =>  {
                                            return <div key={index} className="registration">{item.zichtbaar ? item.medewerker.naam : 'Anoniem'}</div>
                                        })
                                    }
                                    </>
                                    :
                                    <p>Er zijn nog geen aanmeldingen</p>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
           
            <Toaster />
        </div>
        <BottomNav page="/evenement" />
        <img src={svzArtwork} className="artwork" />
    </div>
    );
};
export default Evenement;